import GTMScript from "@/component/Ads/GTMScript";
import BreadcrumbSchema from "@/component/SeoTags/BreadcrumbSchema";
import HeadTag from "@/component/SeoTags/HeadTag";

const index = () => {
  return (
    <article className="mx-4">
      <HeadTag
        title="About us - NewsTak"
        description="Know more about us - NewsTak"
        keywords="about us NewsTak"
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + "/about-us"}
        image={`https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/brand-logo-1-ns.png`}
      />
      <GTMScript />
      <BreadcrumbSchema
        breadcrumbList={[
          {
            title: "About Us",
            canonical_url: process.env.NEXT_PUBLIC_WEBSITE_URL + "/about-us",
          },
        ]}
      />
      <h1 className="text-2xl font-bold">About Us</h1>
      <div className="mt-4 flex flex-col gap-4 text-gray-500 text-md font-extralight">
        <p className="font-normal text-[#666d73] text-[14px]">
          इंडिया टुडे के Tak क्लस्टर News Tak की वेबसाइट
          <a
            href={process.env.NEXT_PUBLIC_WEBSITE_URL}
            rel="noopener noreferrer"
            target="_blank"
          >
            <span className="text-primary">newstak.in</span>{" "}
          </a>
          , देशभर की ताजातरीन राजनीतिक खबरों का सबसे भरोसेमंद स्रोत है. आपको
          <a
            href={process.env.NEXT_PUBLIC_WEBSITE_URL}
            rel="noopener noreferrer"
            target="_blank"
          >
            <span className="text-primary">newstak.in</span>
          </a>
          पर भारत की राजनीति, चुनावों से जुड़ी खबरें और उनका विश्वलेषण विस्तृत
          और तथ्यपरक रूप में मिलता है. यह कवरेज टेक्स्ट न्यूज, वीडियो न्यूज के
          रूप में पाठकों के लिए 24*7 मोड में प्रस्तुत की जाती है. देश के सभी
          हिस्सों में मौजूद स्टेट ब्यूरो टीम के अलावा News Tak के पास रिपोर्टर/
          संवाददाताओं का विशाल नेटवर्क है. इस नेटवर्क की मदद से News Tak आपके
          पास देश की सियासत, चुनावी घमासान की निष्पक्ष और सटीक रिपोर्ट्स
          प्रस्तुत करता है. देश के राजनीतिक समाचार के मामले में, हमारी अनुभवी
          टीम आपको सबसे सटीक और निष्पक्ष रिपोर्टिंग प्रदान करती है. भारत में बात
          लोकसभा चुनावों की हो या विधानसभा चुनावों की, उपचुनाव हों या किस प्रदेश
          के निकाय चुनाव, ग्रामपंचायतों की लड़ाई हो या म्यूनिसिपैलिटी, मेयर
          इलेक्शन News Tak की कवरेज आपको सही सियासी तस्वीर समझने में पूरी मदद
          करती है.
        </p>
      </div>
    </article>
  );
};

export default index;
